"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformChecker = void 0;
const eosjs_ios_browser_signature_provider_interface_1 = require("eosjs-ios-browser-signature-provider-interface");
const eosjs_signature_provider_interface_1 = require("eosjs-signature-provider-interface");
const eosjs_window_message_signature_provider_interface_1 = require("eosjs-window-message-signature-provider-interface");
const uuid_1 = __importDefault(require("uuid"));
var Platform;
(function (Platform) {
    Platform["IOS"] = "ios";
    Platform["DESKTOP_CHROME"] = "desktopChrome";
    Platform["NOT_SUPPORTED"] = "notSupported";
})(Platform || (Platform = {}));
class PlatformChecker {
    constructor(options) {
        this.options = options;
        this.options = options;
    }
    get declaredDomain() {
        const browserUrl = window.location.href;
        const arr = browserUrl.split('/');
        const declaredDomain = `${arr[0]}//${arr[2]}`;
        return declaredDomain;
    }
    get platform() {
        const isIOS = this.userAgent.includes('iPhone') || this.userAgent.includes('iPad');
        const isEmbeddedIOS = (window.webkit && window.webkit.messageHandlers);
        if (isIOS && !isEmbeddedIOS) {
            return Platform.IOS;
        }
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(this.userAgent);
        const isDesktopChrome = this.userAgent.includes('Chrome') && !isMobile;
        if (isDesktopChrome) {
            return Platform.DESKTOP_CHROME;
        }
        return Platform.NOT_SUPPORTED;
    }
    get userAgent() {
        if ('userAgent' in window.navigator) {
            return window.navigator.userAgent;
        }
        else {
            return window.navigator.product.toLowerCase();
        }
    }
    getReturnUrl() {
        return __awaiter(this, void 0, void 0, function* () {
            return window.location.href;
        });
    }
    isSupportedPlatform() {
        return this.platform !== Platform.NOT_SUPPORTED;
    }
    isAvailable() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.platform === Platform.DESKTOP_CHROME) {
                return yield this.isExtensionInstalled();
            }
            return this.isSupportedPlatform();
        });
    }
    getSupportedSignatureProvider() {
        switch (this.platform) {
            case Platform.IOS:
                return eosjs_ios_browser_signature_provider_interface_1.SignatureProvider;
            case Platform.DESKTOP_CHROME:
                return eosjs_window_message_signature_provider_interface_1.SignatureProvider;
            default:
                return eosjs_ios_browser_signature_provider_interface_1.SignatureProvider;
        }
    }
    isExtensionInstalled() {
        return __awaiter(this, void 0, void 0, function* () {
            window.addEventListener('message', this.onWindowMessage.bind(this));
            const promise = new Promise((resolve, reject) => {
                this.pendingRequest = { resolve, reject };
            });
            const request = yield this.createInstallationCheckRequest();
            const requestEnvelope = eosjs_signature_provider_interface_1.packEnvelope(request);
            window.postMessage(requestEnvelope, this.declaredDomain);
            setTimeout(this.installationCheckResponseNotReceived.bind(this), PlatformChecker.MESSAGE_WAIT_TIMEOUT);
            return promise;
        });
    }
    createInstallationCheckRequest() {
        return __awaiter(this, void 0, void 0, function* () {
            const returnUrl = yield this.getReturnUrl();
            return {
                version: '0.0.1',
                id: uuid_1.default(),
                declaredDomain: this.declaredDomain,
                returnUrl,
                request: {
                    installationCheck: {}
                },
            };
        });
    }
    installationCheckResponseNotReceived() {
        if (this.pendingRequest) {
            this.pendingRequest.resolve(false);
            this.pendingRequest = null;
        }
    }
    installationCheckResponseReceived() {
        if (this.pendingRequest) {
            this.pendingRequest.resolve(true);
            this.pendingRequest = null;
        }
    }
    onWindowMessage(event) {
        const packedResponseEnvelope = event.data;
        try {
            const responseEnvelope = eosjs_signature_provider_interface_1.unpackEnvelope(packedResponseEnvelope);
            if ('installationCheck' in responseEnvelope.response) {
                this.installationCheckResponseReceived();
            }
        }
        catch (e) {
            // Data coming over message event was from some other source; ignore it
        }
    }
}
exports.PlatformChecker = PlatformChecker;
PlatformChecker.MESSAGE_WAIT_TIMEOUT = 1000;
